import { render } from "./ScrollTopComponent.vue?vue&type=template&id=492ed7b8&scoped=true"
import script from "./ScrollTopComponent.vue?vue&type=script&lang=js"
export * from "./ScrollTopComponent.vue?vue&type=script&lang=js"

import "./ScrollTopComponent.vue?vue&type=style&index=0&id=492ed7b8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492ed7b8"]])

export default __exports__